<div class="alert alert--{{ type }}">
	<ng-content></ng-content>
</div>